import { render, staticRenderFns } from "./PageHeaderPlain.vue?vue&type=template&id=13d05520&"
import script from "./PageHeaderPlain.vue?vue&type=script&lang=js&"
export * from "./PageHeaderPlain.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/pages/plain.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports